module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="c-panneauDeroulant groupecompteurs-consultation"> \r\n    <fieldset class="cw-fieldset groupecompteurs-consultation-detail">        \r\n          <div class="form-group groupecompteurs-consultation-groupe">\r\n            <label for="groupe" class="text-left cw-required">'+
((__t=(i18n.t("common:resultatgrpcompteurs.groupe")))==null?'':__t)+
'</label>\r\n            <span class="cmbGroupe"></span>\r\n          </div>        \r\n    </fieldset>\r\n    <div class="groupecompteurs-consultation-empty cw-titreBrique">\r\n      '+
((__t=(i18n.t("common:resultatgrpcompteurs.aucun_groupe")))==null?'':__t)+
'\r\n    </div>\r\n</div>\r\n';
}
return __p;
};
